export default __webpack_public_path__ + "static/media/bambora-api.24ac8a1f.png";